import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { APP_ROUTE_PATHS } from '../core/routing/app-route-paths';

@Component({
  selector: 'wm-not-found-page',
  imports: [RouterLink],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundPageComponent {
  protected readonly signInPath = `/${APP_ROUTE_PATHS.signIn}`;
}
